<template lang="html">
  <h1>SLEEP HOMIE</h1>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/test.vue